import {Axis} from '@visx/xychart';
import React from 'react';

import {TickLabelFormatter} from 'ui-library/charting/internals/utils/getTickLabelFormatter';

export interface BaseAxisProps {
  label?: string;
  suggestedNumTicks: number;
  tickLabelFormatter: TickLabelFormatter;
}
export type XAxisProps = BaseAxisProps & {
  tickLabelRotation: number;
};

export function getXAxisTickLabelProps(
  tickLabelRotation: number
): (_value: unknown, _index: number, _values: Array<unknown>) => {angle?: number; textAnchor?: 'end'} {
  return () =>
    tickLabelRotation !== 0
      ? {
          angle: -tickLabelRotation,
          textAnchor: 'end',
        }
      : {};
}

export function XAxis(props: XAxisProps): JSX.Element {
  return (
    <Axis
      hideTicks={true}
      label={props.label}
      numTicks={props.suggestedNumTicks}
      orientation="bottom"
      tickFormat={props.tickLabelFormatter}
      tickLabelProps={getXAxisTickLabelProps(props.tickLabelRotation)}
    />
  );
}

export function YAxis(props: BaseAxisProps): JSX.Element {
  return (
    <Axis
      hideTicks={true}
      label={props.label}
      numTicks={props.suggestedNumTicks}
      orientation="left"
      tickFormat={props.tickLabelFormatter}
    />
  );
}
